import RadioGroup from 'shared/RadioGroup';

import useSubmitOrchestrateForm from 'hooks/useSubmitOrchestrateForm';

import Heading from '../../components/Heading';

const ITEMS = [
  {
    label: 'Pay with Insurance',
    value: 'yes'
  },
  {
    label: 'Pay without Insurance',
    value: 'no'
  }
];

const WithOrWithoutInsurance: React.FC<{ onContinue: (value: boolean) => void }> = ({
  onContinue
}) => {
  const { send, isLoading } = useSubmitOrchestrateForm();

  const handleSelect = (v: string) => {
    if (v) {
      send('mif_qa', [{ answer: v, question: 'use_insurance_for_appointment' }], () => {
        onContinue(v === 'yes');
      });
    }
  };

  return (
    <div className="flex flex-col gap-6 md:mx-auto md:max-w-[500px]">
      <Heading
        category="Plan"
        subtitle={
          <span className="text-mSm">
            We’ll check to see if your insurance plan covers LifeMD appointments.
          </span>
        }
        title="How will you be paying for this appointment?"
      />
      <RadioGroup isLoading={isLoading} items={ITEMS} onSelect={handleSelect} />
    </div>
  );
};

export default WithOrWithoutInsurance;
